import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';

import { trackEvent, togglePackageOptionsEvent } from '../utils/analytics';

const SinglePackage = (props) => {
	const [open, setOpen] = useState(false);

	const toggleOptions = () => {
		const { windowId, widgetName } = props.widgetInfo;
		setOpen((prevState) => !prevState);
		trackEvent(togglePackageOptionsEvent(widgetName, windowId));
	};

	const renderOptions = (
		options = [],
		indentStyles = '',
		hasLink = false
	) => {
		const linkVisibility = open ? 'hidden' : '';
		const collapseLink = hasLink ? (
			<li className={`${linkVisibility}`}>
				<button
					key="button"
					type="button"
					onClick={toggleOptions}
					className="text-link"
				>
					Show All Package Items
				</button>
			</li>
		) : null;
		return (
			<ul className={`list-unstyled list-spaced ${indentStyles}`}>
				{options.map((item) => (
					<li key={item}>{item}</li>
				))}
				{collapseLink}
			</ul>
		);
	};

	const {
		deviceType,
		idx,
		packageName,
		packageOptions,
		packagePrice,
		showPricing
	} = props;

	if (idx === undefined || !packageName) {
		return null;
	}
	const indentStyles = deviceType === 'DESKTOP' ? 'ml-6' : '';
	const packageTitleMargin = idx === 0 ? 'mb-4' : 'my-4';

	const displayPrice =
		packagePrice !== '0' ? (
			<span className="ml-auto pl-5 package-price">{`${packagePrice}`}</span>
		) : null;

	// if price doesn't exist, make name column full width so as to not wrap early
	let renderedOptions;
	let additionalOptions;

	if (packageOptions.length === 0) {
		// do nothing
	} else if (packageOptions.length < 5) {
		// render all options if 4 or less
		renderedOptions = renderOptions(packageOptions, indentStyles);
	} else {
		// render first 3 options and have link to show the rest
		const firstThreeOptions = packageOptions.slice(0, 3);
		const remainingOptions = packageOptions.slice(3);
		renderedOptions = renderOptions(firstThreeOptions, indentStyles, true);
		const renderedremainingOptions = renderOptions(
			remainingOptions,
			indentStyles
		);
		additionalOptions = [
			<Collapse key="collapse" in={open}>
				{renderedremainingOptions}
			</Collapse>
		];
	}
	return (
		<div>
			<strong className={`${packageTitleMargin} d-flex`}>
				<span className="package-title">{packageName}</span>
				{showPricing ? displayPrice : null}
			</strong>
			{renderedOptions}
			{additionalOptions}
		</div>
	);
};

SinglePackage.defaultProps = {
	idx: undefined,
	packageName: undefined,
	packageOptions: [],
	packagePrice: '0',
	widgetInfo: {
		windowId: 'packages-options1',
		widgetName: 'ws-packages-options'
	}
};

SinglePackage.propTypes = {
	deviceType: PropTypes.string.isRequired,
	idx: PropTypes.number,
	packageName: PropTypes.string,
	packageOptions: PropTypes.arrayOf(PropTypes.string.isRequired),
	packagePrice: PropTypes.string,
	showPricing: PropTypes.bool.isRequired,
	widgetInfo: PropTypes.shape({
		windowId: PropTypes.string,
		widgetName: PropTypes.string
	})
};

export default SinglePackage;
